module.exports = __webpack_public_path__ + "assets/img/download-btn-e302a1fb.png";